

var _uiRouter = require('uiRouter');

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    // Decorate the current state with the transition params
    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        _uiRouter.$state.toState = toState;
        _uiRouter.$state.toParams = toParams;
        _uiRouter.$state.fromState = fromState;
        _uiRouter.$state.fromParams = fromParams;
    });
});

_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ./js/lib/stateChangeListener.js
// module id = ./js/lib/stateChangeListener.js
// module chunks = 0